import { render, staticRenderFns } from "./base-form.vue?vue&type=template&id=1f5e071f&scoped=true"
import script from "./base-form.vue?vue&type=script&lang=js"
export * from "./base-form.vue?vue&type=script&lang=js"
import style0 from "./base-form.vue?vue&type=style&index=0&id=1f5e071f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f5e071f",
  null
  
)

export default component.exports